import { createAction, createReducer } from 'redux-act';
import { possibleLengthUnitFormat } from '../../constants';
import { setLengthUnitFormat } from '../../utils/data-formatter';

const DEFAULT_APPLICATION_PARAMETERS_STATE = { lengthUnit: possibleLengthUnitFormat.mm, fullScreenEnabled: true };

export const setLengthUnitAction = createAction('SET_LENGTH_UNIT');
export const setFullScreenModeAction = createAction('SET_FULL_SCREEN');

export const applicationParametersReducer = createReducer(function (on, off) {
  on(setLengthUnitAction, (state, payload) => {
    const newState = {
      ...state,
      lengthUnit: payload
    };
    try {
      localStorage.setItem('msxApplicationParameters', JSON.stringify(newState));
    } catch (error) {
    }
    return newState;
  });
  on(setFullScreenModeAction, (state, payload) => {
    return {
      ...state,
      fullScreenEnabled: payload
    };
  });
}, DEFAULT_APPLICATION_PARAMETERS_STATE);

export function initParameters() {
  return dispatch => {
    try {
      const applicationParameters = JSON.parse(localStorage.getItem('msxApplicationParameters'));
      if (applicationParameters) {
        _setApplicationParameters(applicationParameters, dispatch);
      } else {
      }
    } catch (error) {
      _setApplicationParameters(DEFAULT_APPLICATION_PARAMETERS_STATE, dispatch);
    }
  }
}

export function setApplicationParameters(parameters) {
  return dispatch => {
    _setApplicationParameters(parameters, dispatch);
  }
}

function _setApplicationParameters(parameters, dispatch) {
  if (Object.values(possibleLengthUnitFormat).indexOf(parameters?.lengthUnit) !== -1) {
    dispatch(setLengthUnitAction(parameters?.lengthUnit));
    setLengthUnitFormat(parameters?.lengthUnit);
  }
  if (parameters.fullScreenEnabled != null) {
    dispatch(setFullScreenModeAction(parameters?.fullScreenEnabled));
  }
}
